function eqSet<T = unknown>(a: Set<T>, b: Set<T>) {
  if (a.size !== b.size) return false
  for (const v of a) if (!b.has(v)) return false
  return true
}

export default eqSet
